import { gql } from "@apollo/client";

export const GET_STACK_CONFIGS = gql`
  query GetStackConfigs($id: ID!) {
    stack(id: $id) {
      id
      attachedContexts {
        contextName
        id
        contextId
        isAutoattached
        priority
      }
      roleBindings {
        id
        role {
          id
          slug
        }
        space {
          id
        }
      }
      attachedAwsIntegrations {
        id
        integrationId
        isAutoattached
        read
        write
      }
      attachedAzureIntegrations {
        id
        integrationId
        isAutoattached
        read
        subscriptionId
        write
      }
      integrations {
        gcp {
          activated
          tokenScopes
        }
      }
      config {
        id
        runtime
        type
        createdAt
        writeOnly
        description
        value
      }
      hooks {
        afterApply
        beforeApply
        afterInit
        beforeInit
        afterPlan
        beforePlan
        afterPerform
        beforePerform
        afterDestroy
        afterRun
        beforeDestroy
      }
    }
  }
`;
